import axios from 'axios';
import { BASE_URL } from '../ApiService/ApiConfig';

const obtenerConfig = () => {
    const token = localStorage.getItem('jwt').replaceAll('"', '');
    return {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            Authorization: 'Bearer ' + token
        }
    };
};

const URL = `${BASE_URL}/siniestroGrupo`;

export const listarGruposActivos = async () => {
    const response = await axios.get(URL, obtenerConfig());
    return response.data;
};

/** Grupos activos a los que pertenece el usuario logueado (como miembro). */
export const listarMisGrupos = async () => {
    const response = await axios.get(`${URL}/misGrupos`, obtenerConfig());
    return response.data;
};

export const obtenerGrupoPorId = async (siniestroGrupoId) => {
    const response = await axios.get(`${URL}/${siniestroGrupoId}`, obtenerConfig());
    return response.data;
};

export const crearGrupo = async (objData) => {
    const response = await axios.post(URL, objData, obtenerConfig());
    return response.data;
};

export const actualizarGrupo = async (objData) => {
    const response = await axios.put(URL, objData, obtenerConfig());
    return response.data;
};

export const anularGrupo = async (siniestroGrupoId) => {
    const response = await axios.get(`${URL}/anular/${siniestroGrupoId}`, obtenerConfig());
    return response.data;
};

/** Reemplaza la lista completa de usuarios del grupo. */
export const reemplazarUsuariosGrupo = async (siniestroGrupoId, usuariosIds) => {
    const response = await axios.post(
        `${URL}/${siniestroGrupoId}/usuarios`,
        { usuariosIds },
        obtenerConfig()
    );
    return response.data;
};

export const obtenerUsuariosDisponibles = async () => {
    const response = await axios.get(`${URL}/usuarios/disponibles`, obtenerConfig());
    return response.data;
};

export const esAdminSiniestros = async () => {
    const response = await axios.get(`${URL}/esAdmin`, obtenerConfig());
    return response.data?.esAdmin === true;
};

/** Sube (o reemplaza) el logo del grupo. archivo es un File de un <input type=file>. */
export const subirLogoGrupo = async (siniestroGrupoId, archivo) => {
    const token = localStorage.getItem('jwt').replaceAll('"', '');
    const formData = new FormData();
    formData.append('archivo', archivo);
    const response = await axios.post(`${URL}/${siniestroGrupoId}/logo`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: 'Bearer ' + token
        }
    });
    return response.data;
};

/** Descarga el binario del logo del grupo como Blob. Devuelve null si no tiene logo. */
export const descargarLogoGrupo = async (siniestroGrupoId) => {
    const token = localStorage.getItem('jwt').replaceAll('"', '');
    try {
        const response = await axios.get(`${URL}/${siniestroGrupoId}/logo`, {
            responseType: 'blob',
            headers: { Authorization: 'Bearer ' + token }
        });
        return response.data;
    } catch (e) {
        if (e?.response?.status === 404) return null;
        throw e;
    }
};

export const eliminarLogoGrupo = async (siniestroGrupoId) => {
    const response = await axios.delete(`${URL}/${siniestroGrupoId}/logo`, obtenerConfig());
    return response.data;
};

/**
 * Devuelve el grupo del usuario logueado si tiene exactamente 1 grupo con logo
 * (para mostrarlo en el header). Devuelve null si no aplica (204 No Content).
 */
export const obtenerMiGrupoConLogo = async () => {
    const response = await axios.get(`${URL}/miLogo`, obtenerConfig());
    if (response.status === 204 || !response.data) return null;
    return response.data; // { siniestroGrupoId, nombre, logoTipoMime }
};
